import React from 'react';

import { cn } from '../../../utils/cn.js';

export default function PortalSubHeading({ children, className }) {
  return (
    <h2
      className={cn(
        'font-lively text-xl font-bold text-portal-text ',
        className,
      )}
    >
      {children}
    </h2>
  );
}
